import ReactQuill from 'react-quill';
import { FormControl, TextField } from '@mui/material';
import { Typography } from '@mui/material';

import styles from './MessagesSurvey.module.css';

export const MessagesSurvey = ({ surveyMessages, setSurveyMessages, quillModules }) => {
  const handleChangeMessage = (propertyName, value) => {
    setSurveyMessages((prev) => ({
      ...prev,
      [propertyName]: value,
    }));
  };

  return (
    <div className={styles.form}>
      <Typography
        variant="h6"
        style={{ fontWeight: 'bold', marginBottom: '15px' }}
      >
        Configuración mensaje de bienvenida encuesta:
      </Typography>
      <FormControl
        style={{
          marginBottom: '1.5em',
        }}
      >
        {/*
        <TextField
          id="title"
          label="Mensaje de solicitud de ingreso"
          value={surveyMessages.welcomeMessage}
          name="welcomeMessage"
          fullWidth
          onChange={(event) => handleChangeMessage('welcomeMessage', event)}
          multiline
          rows={2}
        />*/}
        <ReactQuill
          theme="snow"
          value={surveyMessages.welcomeMessage}
          onChange={(value) => handleChangeMessage('welcomeMessage', value)}
          modules={quillModules}
          placeholder="Mensaje de solicitud de ingreso..."
          style={{
            backgroundColor: '#fff',
            borderRadius: '4px',
            marginBottom: '8px',
          }}
        />
      </FormControl>
      <FormControl
        style={{
          marginBottom: '1.5em',
        }}
      >
        <TextField
          id="title"
          label="Tooltip para el campo de ingreso"
          value={surveyMessages.inputMessage}
          name="inputMessage"
          fullWidth
          onChange={(event) => handleChangeMessage('inputMessage', event.target.value)}
        />
      </FormControl>
      <FormControl
        style={{
          marginBottom: '1.5em',
        }}
      >
        {/*
        <TextField
          id="title"
          label="Mensaje confidencialidad"
          value={surveyMessages.confidentialityMessage}
          name="confidentialityMessage"
          fullWidth
          onChange={(event) =>
            handleChangeMessage('confidentialityMessage', event)
          }
          multiline
          rows={3}
        />*/}
        <ReactQuill
        theme="snow"
        value={surveyMessages.confidentialityMessage}
        onChange={(value) => handleChangeMessage('confidentialityMessage', value)}
        modules={quillModules}
        placeholder="Mensaje confidencialidad..."
        style={{
          backgroundColor: '#fff',
          borderRadius: '4px',
          marginBottom: '8px',
        }}
      />
            </FormControl>
    </div>
  );
};
